import { render } from "./Declined.vue?vue&type=template&id=a116a672&scoped=true"
import script from "./Declined.vue?vue&type=script&lang=js"
export * from "./Declined.vue?vue&type=script&lang=js"

import "./Declined.vue?vue&type=style&index=0&id=a116a672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a116a672"]])

export default __exports__